module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"FuzzyTree","commonjs2":"fuzzytree","commonjs":"fuzzytree","amd":"fuzzytree"}
 ** module id = 3
 ** module chunks = 0
 **/